import { ILocaleSiteLinks } from '@Hotels-at-Home/hah-fe-core/dist/types/header';
import { IImage } from '@Hotels-at-Home/hah-fe-core/dist/types/image';

export const siteLinks: ILocaleSiteLinks = {
  en: [
    {
      id: 1,
      url: 'https://europe.shopmarriott.com/en?___store=mareu_en&utm_source=HAH&utm_medium=site-RHR&utm_content=MAREU&utm_term=MAR&utm_campaign=PanBrand-Header-Links',
      title: 'Shop Marriott',
    },
    {
      id: 2,
      url: 'https://europe.westinstore.com/en?___store=hbeu_en&utm_source=HAH&utm_medium=site-RHR&utm_content=HBEU&utm_term=MAR&utm_campaign=PanBrand-Header-Links',
      title: 'Westin Store',
    },
    {
      id: 3,
      url: 'https://europe.sheratonstore.com/en?referrer=internal&utm_source=HAH&utm_medium=site-RHR&utm_content=SHEU&utm_term=MAR&utm_campaign=PanBrand-Header-Links',
      title: 'Sheraton Store',
    },
    {
      id: 4,
      url: 'https://europe.shoplemeridien.com/en?referrer=internal&utm_source=HAH&utm_medium=site-RHR&utm_content=LEMEU&utm_term=MAR&utm_campaign=PanBrand-Header-Links',
      title: 'Shop Le Meridien',
    },
  ],
  fr: [
    {
      id: 1,
      url: 'https://europe.shopmarriott.com/fr?___store=mareu_fr&utm_source=HAH&utm_medium=site-RHR&utm_content=MAREU&utm_term=MAR&utm_campaign=PanBrand-Header-Links',
      title: 'Shop Marriott',
    },
    {
      id: 2,
      url: 'https://europe.westinstore.com/fr?___store=hbeu_fr&utm_source=HAH&utm_medium=site-RHR&utm_content=HBEU&utm_term=MAR&utm_campaign=PanBrand-Header-Links',
      title: 'Westin Store',
    },
    {
      id: 3,
      url: 'https://europe.sheratonstore.com/fr?referrer=internal&utm_source=HAH&utm_medium=site-RHR&utm_content=SHEU&utm_term=MAR&utm_campaign=PanBrand-Header-Links',
      title: 'Sheraton Store',
    },
    {
      id: 4,
      url: 'https://europe.shoplemeridien.com/fr?___store=lemeu_fr&utm_source=HAH&utm_medium=site-RHR&utm_content=LEMEU&utm_term=MAR&utm_campaign=PanBrand-Header-Links',
      title: 'Shop Le Méridien',
    },
  ],
  de: [
    {
      id: 1,
      url: 'https://europe.shopmarriott.com/de?___store=mareu_de&utm_source=HAH&utm_medium=site-RHR&utm_content=MAREU&utm_term=MAR&utm_campaign=PanBrand-Header-Links',
      title: 'Shop Marriott',
    },
    {
      id: 2,
      url: 'https://europe.westinstore.com/de?___store=hbeu_de&utm_source=HAH&utm_medium=site-RHR&utm_content=HBEU&utm_term=MAR&utm_campaign=PanBrand-Header-Links',
      title: 'Westin Store',
    },
    {
      id: 3,
      url: 'https://europe.sheratonstore.com/de?referrer=internal&utm_source=HAH&utm_medium=site-RHR&utm_content=SHEU&utm_term=MAR&utm_campaign=PanBrand-Header-Links',
      title: 'Sheraton Store',
    },
    {
      id: 4,
      url: 'https://europe.shoplemeridien.com/de?___store=lemeu_de&utm_source=HAH&utm_medium=site-RHR&utm_content=LEMEU&utm_term=MAR&utm_campaign=PanBrand-Header-Links',
      title: 'Shop Le Méridien',
    },
  ],
  es: [
    {
      id: 1,
      url: 'https://europe.shopmarriott.com/es?___store=mareu_es&utm_source=HAH&utm_medium=site-RHR&utm_content=MAREU&utm_term=MAR&utm_campaign=PanBrand-Header-Links',
      title: 'Shop Marriott',
    },
    {
      id: 2,
      url: 'https://europe.westinstore.com/es/?___store=hbeu_es&utm_source=HAH&utm_medium=site-RHR&utm_content=HBEU&utm_term=MAR&utm_campaign=PanBrand-Header-Links',
      title: 'Westin Store',
    },
    {
      id: 3,
      url: 'https://europe.sheratonstore.com/es?referrer=internal&utm_source=HAH&utm_medium=site-RHR&utm_content=SHEU&utm_term=MAR&utm_campaign=PanBrand-Header-Links',
      title: 'Sheraton Store',
    },
    {
      id: 4,
      url: 'https://europe.shoplemeridien.com/es/?___store=lemeu_es&utm_source=HAH&utm_medium=site-RHR&utm_content=LEMEU&utm_term=MAR&utm_campaign=PanBrand-Header-Links',
      title: 'Shop Le Méridien',
    },
  ],
};

export const bonvoyLogo: IImage = {
  src: '/images/misc/bonvoy-logo.svg',
  alt: 'Shop logo',
  height: '47.25',
  width: '100',
};
